import { authMessage, Embedding } from '@app/shared/shell/shell-protocol';
import Keycloak, { KeycloakInitOptions } from 'keycloak-js';

/** Ouverte seule, l'application se connecte elle-même par la page de l'annuaire, comme avant. */
export function standaloneInitOptions(): KeycloakInitOptions {
  return { onLoad: 'login-required' };
}

/**
 * Dans le cadre de la coque, l'application reprend sans rien demander la session ouverte dans
 * l'annuaire en se connectant à la coque : vérification silencieuse, jamais de redirection vers
 * la page de connexion, qui refuse de s'afficher dans un cadre (contrat des logiciels, § 3).
 * `silent-check-sso.html` est servi à côté de `index.html` (dossier `public/`).
 */
export function embeddedInitOptions(origin: string): KeycloakInitOptions {
  return {
    onLoad: 'check-sso',
    silentCheckSsoRedirectUri: `${origin}/silent-check-sso.html`,
    // Cookies tiers bloqués, keycloak-js remplacerait par défaut la vérification silencieuse
    // par une redirection du cadre vers l'annuaire : CDT ne rendrait jamais la main.
    silentCheckSsoFallback: false,
    pkceMethod: 'S256',
    // Le cadre de surveillance de session a lui aussi besoin des cookies tiers ; bloqué, il
    // déconnecterait à tort.
    checkLoginIframe: false,
  };
}

/**
 * Initialise le client embarqué. Sans session reconnue, ou sans annuaire joignable, l'application
 * envoie `dode:auth` et attend sans rien afficher : la coque renouvelle sa session et recharge
 * le cadre (§ 4.4). La promesse ne se résout alors jamais, et l'application ne démarre pas.
 */
export async function initEmbeddedKeycloak(
  keycloak: Keycloak,
  embedding: Embedding,
  origin: string,
): Promise<void> {
  const recognised = await keycloak.init(embeddedInitOptions(origin)).catch((error: unknown) => {
    console.error("L'annuaire n'a pas pu vérifier la session", error);
    return false;
  });
  if (!recognised) {
    embedding.parent.postMessage(authMessage(), embedding.coque);
    await new Promise<never>(() => undefined);
  }
}
